import { useRef, forwardRef, useImperativeHandle } from "react";
import { animated } from "react-spring";
import { useTranslation } from "react-i18next";

const HardeningTemperingUI = forwardRef(({ style }, ref) => {
  const loadingRef = useRef();
  const { t } = useTranslation();

  useImperativeHandle(ref, () => ({
    loading: (v) => {
      if (loadingRef.current) {
        loadingRef.current.style.width = v;
      }
    },
  }));

  return (
    <>
      <animated.div
        style={{
          ...style,
          position: "absolute",
          bottom: "4vh",
          width: "100%",
          height: "3px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "3px",
            borderRadius: "3px",
            width: "17vw",
            backgroundColor: "#fff",
          }}
        >
          <div
            ref={loadingRef}
            style={{
              height: "3px",
              width: "0%",
              backgroundColor: "#37A46E",
              borderRadius: "3px",
            }}
          />
        </div>
      </animated.div>
      <animated.div
        style={{
          ...style,
          position: "absolute",
          bottom: "4vh",
          left: "2vw",
          width: "20vw",
          display: "flex",
          padding: "2vw 2.5vw",
          alignItems: "center",
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          color: "#fff",
          fontSize: "0.9vw",
        }}
      >
        {t("L4_HARDENING_TIMELINE_DESCRIPTION")}
      </animated.div>
    </>
  );
});

export default HardeningTemperingUI;
